<template>
  <div class="neu-footer-section">
    <div class="section__container">
      <p class="neu-footer__title">
        Get in touch with us!
      </p>
      <v-btn elevation="0" class="neu-footer__btn" size="x-large" @click="redirectToCalendly">Schedule a Meeting</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "NeuFooterSektion",
  methods: {
    redirectToCalendly() {
      window.open(
        process.env.VUE_APP_CALENDLY_LINK,
        "_blank"
      );
    },
  }

}
</script>

<style scoped>
.neu-footer-section {
  display: grid;
  align-items: center;
  justify-content: center;
  background-color: #DEF3FF;
  height: 15rem;
  padding-inline: var(--about-page-gutter, clamp(1rem, 4vw, 2rem));
}

.section__container {
  width: 100%;
  max-width: var(--about-content-max, 1400px);
  margin-inline: auto;
}

.neu-footer__title {
  font-family: 'DM Sans Bold', sans-serif;
  font-size: 2rem;
  margin-bottom: 1rem;
}

.neu-footer__btn {
  background-color: #007AB2;
  color: var(--light-1);
  font-family: 'Manrope Medium', sans-serif;
  text-transform: capitalize;
  letter-spacing: 0px;
  border-radius: 8px;
}
.neu-footer__btn:hover{
  background-color: #00AEFF;
}

@media (max-width: 960px) {
  .neu-footer-section {
    padding-inline: var(--about-mobile-section-gutter, calc(1rem + 12px));
  }
}
</style>
